import React from 'react';
import { Link } from 'react-router-dom';
import './ProductDetail.css';
import QuickInquiryWidget from '../../components/QuickInquiryWidget';

const WHATSAPP_MESSAGE = "Hi HOPE INTERNATIONAL, I'm interested in your export products. Please share quotation and product details.";
const WHATSAPP_LINK = `https://wa.me/916267592923?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

function AmlaPage() {
  return (
    <div className="product-detail-page">
      <QuickInquiryWidget productName="Amla Fruit Powder" botanical="Emblica officinalis" />
      <div className="product-detail-container">
        <div className="product-detail-header">
          <h1>Amla Powder</h1>
          <p className="botanical-name">Emblica officinalis</p>
          <div className="title-underline"></div>
        </div>

        <div className="top-action-buttons">
          <Link to="/request-quote" className="btn-action-primary">Request a Quote</Link>
          <Link to="/request-sample" className="btn-action-secondary">Request a Sample</Link>
          <Link to="/request-coa" className="btn-action-tertiary">Request COA / Specs</Link>
        </div>

        <section className="product-section">
          <h2>Product Overview</h2>
          <p>Amla Powder, also known as Indian Gooseberry powder, is a vitamin C rich superfood ingredient widely used in health supplements and Ayurvedic formulations. HOPE INTERNATIONAL supplies export-quality Amla powder with consistent sourcing and documentation support.</p>
        </section>

        <section className="product-section">
          <h2>Key Features</h2>
          <ul className="feature-list">
            <li>Natural source of Vitamin C</li>
            <li>Fine powder with characteristic tangy taste</li>
            <li>Suitable for supplements and wellness products</li>
            <li>COA available on request (batch-wise)</li>
          </ul>
        </section>

        <section className="product-section">
          <h2>Typical Applications</h2>
          <div className="applications-grid">
            <div className="application-item">Nutraceutical capsules and tablets</div>
            <div className="application-item">Hair care and skincare formulations</div>
            <div className="application-item">Ayurvedic health supplements</div>
            <div className="application-item">Functional food and beverages</div>
            <div className="application-item">Private label retail packs</div>
          </div>
        </section>

        <section className="product-section specs-section">
          <h2>Available Specifications</h2>
          <p className="specs-note">On Request / As per COA</p>
          <div className="specs-table">
            <div className="spec-row"><span className="spec-label">Form</span><span className="spec-value">Powder</span></div>
            <div className="spec-row"><span className="spec-label">Botanical Name</span><span className="spec-value">Emblica officinalis</span></div>
            <div className="spec-row"><span className="spec-label">Part Used</span><span className="spec-value">Fruit</span></div>
            <div className="spec-row"><span className="spec-label">Mesh Size Options</span><span className="spec-value">60 / 80 / 100 mesh (custom available)</span></div>
            <div className="spec-row"><span className="spec-label">Moisture</span><span className="spec-value">As per batch COA</span></div>
            <div className="spec-row"><span className="spec-label">Shelf Life</span><span className="spec-value">Typically up to 24 months</span></div>
          </div>
        </section>

        <section className="product-section">
          <h2>Packaging Options</h2>
          <div className="packaging-options">
            <div className="package-item"><span className="package-type">Bulk Export Pack</span><span className="package-desc">25 kg kraft paper bag</span></div>
            <div className="package-item"><span className="package-type">Retail Pack</span><span className="package-desc">100g matte pouch</span></div>
            <div className="package-item"><span className="package-type">Retail Pack</span><span className="package-desc">250g matte pouch</span></div>
          </div>
          <p className="packaging-note">Custom labeling available on request</p>
        </section>

        <section className="product-section">
          <h2>Documents Available</h2>
          <ul className="document-list">
            <li>COA (Certificate of Analysis)</li>
            <li>MSDS / SDS</li>
            <li>Certificate of Origin</li>
            <li>Commercial Invoice & Packing List</li>
            <li>Export documentation support</li>
          </ul>
        </section>

        <section className="product-section industries-section">
          <h2>Industries We Serve</h2>
          <div className="industries-list">
            <span>Nutraceutical Manufacturers</span>
            <span>Importers & Distributors</span>
            <span>Food & Beverage Brands</span>
            <span>Private Label Brands</span>
            <span>Ayurveda Companies</span>
          </div>
        </section>

        <section className="product-section">
          <h2>Related Products</h2>
          <div className="related-products">
            <Link to="/product/ashwagandha" className="related-product-link">Ashwagandha Powder</Link>
            <Link to="/product/moringa" className="related-product-link">Moringa Powder</Link>
            <Link to="/product/turmeric" className="related-product-link">Turmeric Powder</Link>
            <Link to="/product/neem" className="related-product-link">Neem Powder</Link>
          </div>
        </section>

        <section className="product-cta-section">
          <h3>Need Amla powder for your health supplement brand?</h3>
          <div className="cta-buttons">
            <Link to="/request-quote" className="btn-cta-primary">Request a Quote</Link>
            <Link to="/request-sample" className="btn-cta-secondary">Request a Sample</Link>
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="btn-cta-whatsapp">WhatsApp Now</a>
          </div>
        </section>
      </div>
    </div>
  );
}

export default AmlaPage;
